export enum ButtonIcon {
  ARROW_RIGHT = 'arrow-right',
  ARROW_RIGHT_SLIM = 'arrow-right-slim',
  QUESTION_MARK = 'question-mark',
  ARROW_DOWN = 'arrow-down',
  ARROW_DOWN_DARK_SEARCH_RESULT_WITHOUT_TEXT_ON_MOBILE = 'arrow-down_dark',
  ARROW_DOWN_DARK_SEARCH_RESULT_WITH_TEXT_ON_MOBILE = 'arrow-down_dark-with-text-on-mobile',
}
